import { useTranslation } from 'react-i18next';
import './benefits.scss';
import utils from '../core/utils';
import possible1 from '../assets/icon/possible-1.svg';
import possible2 from '../assets/icon/possible-2.svg';
import possible3 from '../assets/icon/possible-3.svg';
import possible4 from '../assets/icon/possible-4.svg';
import bgBenefitsLeft from '../assets/background/bg-benefits-left.jpg';
import bgBenefitsRight from '../assets/background/bg-benefits-right.jpg';
import benefitsImage1KOR from '../assets/background/benefits-image-1.png';
import benefitsImage1ENG from '../assets/background/benefits-image-1-eng.png';
import benefitsImage1JPN from '../assets/background/benefits-image-1-jpn.png';
import benefitsImage2KOR from '../assets/background/benefits-image-2.png';
import benefitsImage2ENG from '../assets/background/benefits-image-2-eng.png';
import benefitsImage2JPN from '../assets/background/benefits-image-2-jpn.png';
import aboutImage from '../assets/background/about-image.png';
import { motion } from 'framer-motion';
import { motionX, motionY } from 'src/core/animation';
import { useState } from 'react';
import translateSetting from 'src/core/translate-setting';

const Benefits = () => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();

  let benefitsImage1 = benefitsImage1KOR;
  if (curLng === 'ENG') {
    benefitsImage1 = benefitsImage1ENG;
  }
  if (curLng === 'JPN') {
    benefitsImage1 = benefitsImage1JPN;
  }

  let benefitsImage2 = benefitsImage2KOR;
  if (curLng === 'ENG') {
    benefitsImage2 = benefitsImage2ENG;
  }
  if (curLng === 'JPN') {
    benefitsImage2 = benefitsImage2JPN;
  }

  return (
    <section id="benefits" className="Benefits">
      <div className="content-box">
        <motion.div
          className="left-section"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: false, amount: 0.3 }}
          variants={motionX()}
        >
          <img className="prime-image-1" src={bgBenefitsLeft} />

          <img className="benefits-image" src={benefitsImage1}></img>
          <div className="card-box">
            <div className="row">
              <div className="small-text">{t('benefits.label-0')}</div>
              <div className="big-text">{t('benefits.current-text-0')}</div>
            </div>
            <div className="row">
              <div className="small-text">{t('benefits.label-1')}</div>
              <div className="big-text">{t('benefits.current-text-1')}</div>
            </div>
            <div className="row">
              <div className="small-text">{t('benefits.label-2')}</div>
              <div className="big-text">{t('benefits.current-text-2')}</div>
            </div>
            <div className="row">
              <div className="small-text">{t('benefits.label-3')}</div>
              <div className="big-text">{t('benefits.current-text-3')}</div>
            </div>
            <div className="row">
              <div className="small-text">{t('benefits.label-4')}</div>
              <div className="big-text">{t('benefits.current-text-4')}</div>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="right-section"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: false, amount: 0.3 }}
          variants={motionX({ from: 50, to: 0 })}
        >
          <img className="prime-image-2" src={bgBenefitsRight} />

          <img className="benefits-image" src={benefitsImage2}></img>
          <div className="card-box">
            <div className="text">{t('benefits.future-text-0')}</div>
            <div className="text">{t('benefits.future-text-1')}</div>
            <div className="text">{t('benefits.future-text-2')}</div>
            <div className="text">{t('benefits.future-text-3')}</div>
            <div className="text">{t('benefits.future-text-4')}</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;
